import { render, staticRenderFns } from "./AboutApp.vue?vue&type=template&id=491f0138&scoped=true&"
import script from "./AboutApp.vue?vue&type=script&lang=js&"
export * from "./AboutApp.vue?vue&type=script&lang=js&"
import style0 from "./AboutApp.vue?vue&type=style&index=0&id=491f0138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491f0138",
  null
  
)

export default component.exports